export function valueOrDefault (value, defaultValue) {
  /* v8 ignore next 1 */
  return value || defaultValue
}

export function ternary (condition, valueIfTrue, valueIfFalse) {
  /* v8 ignore next 4 */
  return {
    [true]: valueIfTrue,
    [false]: valueIfFalse
  }[Boolean(condition)]
}

export function shuffle (array) {
  const arr = [...array]
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]]
  }
  return arr
}
